<template>
  <div v-if="!isLoading && hasBandList">
    <template v-for="(sectionInfo, index) in multiSectionList">
      <DynamicSectionLoader :section-info="sectionInfo" :key="sectionInfo.title + $route.name + index" />
    </template>
  </div>
  <div v-else-if="!isLoading && !hasBandList" class="wrap">
    <div class="recommend-empty">
      <img src="../../assets/images/common/icon-error-74.png" alt="error">
      <p>추천 콘텐츠가 없어요.</p>
    </div>
  </div>
</template>
<script>

import { getVodRecommendMultiSection } from '@/common/utils/request'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import _ from 'lodash'
import { onDisplay } from '@/common/resources/directives'
import { scrollToElement } from '@/common/utils/common'

export default {
  components: {
    DynamicSectionLoader
  },
  props: {
    contentInfo: {
      type: Object
    }
  },
  directives: {
    onDisplay
  },
  data () {
    return {
      multiSectionList: [],
      firstLoading: true,
      isLoading: true
    }
  },
  computed: {
    hasBandList () {
      return this.multiSectionList.length
    }
  },
  methods: {
    setData () {
      this.isLoading = true
      getVodRecommendMultiSection({
        programid: _.get(this.contentInfo, 'programid', ''),
        contentid: _.get(this.contentInfo, 'contentid', '')
      }).then(({ data }) => {
        this.multiSectionList = _.get(data, 'multisectionlist', []).filter((multiSection) => multiSection.title !== 'TV컷')
        this.isLoading = false
      })
      if (this.firstLoading) {
        this.firstLoading = false
      } else {
        scrollToElement('.player-nav')
      }
    }
  },
  created () {
    this.setData()
  }
}
</script>
